import m from 'mithril';

export default {
  oncreate({ state, attrs }) {
    $(`#${state.id}`).selectpicker();

    $(`#${state.id}`).on('change', () => {
      const selectElement = document.getElementById(state.id);
      const selectedValues = Array.from(selectElement.selectedOptions)
        .map(option => option.value);

      attrs.onChange(selectedValues);
    });
  },
  onupdate({ state }) {
    $(`#${state.id}`).selectpicker('refresh');
  },
  oninit({ state, attrs }) {
    state.id = Math.random().toString().split('.')[1];
  },
  view({ attrs, state }) {
    const { options = [], multiple = true } = attrs;

    return m(`select#${state.id}.form-control.k_selectpicker`, {
      multiple,
    }, options.map(op => m('option', { selected: op.selected || false, value: op.value }, op.label)));
  },
};
